import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { blogTagService, BlogTag } from '@/services/other-services'
import { toast } from 'sonner'

export function useBlogTags(params?: { all?: boolean; lang?: string }) {
    const queryClient = useQueryClient()

    const query = useQuery({
        queryKey: ['blog-tags', params],
        queryFn: () => blogTagService.getAll(params),
    })

    const createMutation = useMutation({
        mutationFn: blogTagService.create,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog-tags'] })
            toast.success('Yeni etiket oluşturuldu')
        },
        onError: () => toast.error('Etiket oluşturulurken bir hata oluştu'),
    })

    const updateMutation = useMutation({
        mutationFn: ({ id, data }: { id: string; data: Partial<BlogTag> }) =>
            blogTagService.update(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog-tags'] })
            toast.success('Etiket güncellendi')
        },
        onError: () => toast.error('Güncelleme sırasında bir hata oluştu'),
    })

    const deleteMutation = useMutation({
        mutationFn: blogTagService.delete,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['blog-tags'] })
            toast.success('Etiket silindi')
        },
        onError: () => toast.error('Silme işlemi sırasında bir hata oluştu'),
    })

    return {
        ...query,
        createTag: createMutation.mutateAsync,
        updateTag: updateMutation.mutateAsync,
        deleteTag: deleteMutation.mutateAsync,
        isMutating: createMutation.isPending || updateMutation.isPending || deleteMutation.isPending,
    }
}
